import { create } from 'zustand'
import { HookResult } from '../hooks/hookTypes'
import axiosInstance, { axiosRequest } from '../network/axiosInstance'

// Define interfaces for Langflow configuration types
export interface LangflowConfig {
  id: string
  instanceKey: string
  name: string
  description?: string
  isActive: boolean
  configItems: Record<string, any>
  createdBy?: string
  createdAt: string
  updatedAt: string
}

export interface LangflowStoreState {
  configsLoading: boolean
  configsFetchSuccess: boolean
  configsFetchError: boolean
  configs: LangflowConfig[] | null
  configsErrorMessage: string | null
  fetchConfigs: () => Promise<void>
}

// Create a Zustand store for fetching configurations
export const useGetLangflowConfigs = create<LangflowStoreState>((set) => ({
  configsLoading: false,
  configsFetchSuccess: false,
  configsFetchError: false,
  configs: null,
  configsErrorMessage: null,
  fetchConfigs: async () => {
    console.log('fetchLangflowConfigs called')
    set({
      configsLoading: true,
      configsFetchSuccess: false,
      configsFetchError: false,
      configs: null,
      configsErrorMessage: null,
    })
    try {
      const res = await axiosInstance.get('/api/langflow')
      set({
        configsLoading: false,
        configsFetchSuccess: true,
        configs: res.data.configurations,
      })
    } catch (err) {
      console.error('Error fetching Langflow configurations:', err)
      set({
        configsLoading: false,
        configsFetchError: true,
        configsErrorMessage: (err as Error).message,
      })
    }
  },
}))

// Get all Langflow configurations
export const useGetAllLangflowConfigs = axiosRequest({
  method: 'GET',
  url: '/api/langflow',
})

// Get Langflow configuration by ID
export const useGetLangflowConfigById = axiosRequest({
  method: 'GET',
  url: '/api/langflow/:id',
})

// Get Langflow configuration by key
export const useGetLangflowConfigByKey = axiosRequest({
  method: 'GET',
  url: '/api/langflow/key/:key',
})

// Create Langflow configuration
export const useCreateLangflowConfig = axiosRequest({
  method: 'POST',
  url: '/api/langflow',
})

// Update Langflow configuration
export const useUpdateLangflowConfig = axiosRequest({
  method: 'PUT',
  url: '/api/langflow/:id',
})

// Delete Langflow configuration
export const useDeleteLangflowConfig = axiosRequest({
  method: 'DELETE',
  url: '/api/langflow/:id',
})
